(function () {

    'use strict';

    angular
        .module('components')
        .component('hColorSelector', {
            controller: HColorSelectorComponent,
            controllerAs: '$ctrl',
            bindings: {
                name: '@',
                ngModel: '=',
                colorList: '<',
                allowText: '<',
                ngDisabled: '<',
                infoHtml: '<',
                hideCustomColor: '<',
            },
            templateUrl: '../hmodules/components/h-color-selector/h-color-selector.component.ng.html'
        });

    HColorSelectorComponent.$inject = ['$scope', '$element'];

    function HColorSelectorComponent($scope, $element) {

        var self = this;

        self.activeLevels = [];

        self.$onInit = function () {
            if (!self.ngModel) {
                self.ngModel = '#000000';
            }
            self.hexColor = self.ngModel;
            if (!self.colorList) {
                self.colorList = [
                    '#F44336',
                    '#E91E63',
                    '#9C27B0',
                    '#673AB7',
                    '#3F51B5',
                    '#2196F3',
                    '#03A9F4',
                    '#00BCD4',
                    '#009688',
                    '#4CAF50',
                    '#8BC34A',
                    '#CDDC39',
                    '#FFEB3B',
                    '#FFC107',
                    '#FF9800',
                    '#FF5722',
                    '#795548',
                    '#9E9E9E',
                    '#607D8B',
                    '#000000',
                ];
            }
        };

        var closeColorPicker = function () {
            $element.find('.color-picker-dropdown').first().removeClass("open");
        };

        self.onKeyDown = function (event, color) {
            if (event.key === 'Enter') {
                self.selectColor(color);
            }
        };

        self.selectColor = function (color) {
            self.ngModel = color;
            self.hexColor = color;
            closeColorPicker();
        };

        self.handleColorSelection = function(color) {
            self.selectColor(color);
            self.triggerInput();
        };

        self.triggerInput = function () {
            $element.find('#' + self.name).triggerHandler("change");
        };

        self.toggleColorInput = function () {
            self.isColorInputShown = !self.isColorInputShown;
        };

        self.onColorPickerDropdownClick = function (event) {
            event && event.stopPropagation();
        };

        var updateHexColorValue = function () {
            self.hexColor = self.ngModel;
            $scope.$evalAsync();
        };

        self.$postLink = function () {
            $element.find('.color-picker-dropdown').on('shown.bs.dropdown', function () {
                updateHexColorValue();
            });
            $element.find('.color-picker-dropdown').on('hide.bs.dropdown', function () {
                updateHexColorValue();
            });
        };
    }
})();
